<template>
  <el-dialog
    :visible.sync="visible"
    title="关联民宿"
    :append-to-body="true"
    width="80vw"
  >
    <!-- :close-on-click-modal="false"
    :close-on-press-escape="false" -->
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="id"
        label="ID"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="民宿名称"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="价格（元）"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column prop="cover" label="图片" header-align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.cover"
            style="height: 100px; width: 100px; border-radius: 100pxp"
            :src="scope.row.cover.split(',')[0]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="contactPerson"
        label="民宿联系人"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="contactMobile"
        label="手机号"
        header-align="center"
      ></el-table-column>
    </el-table>
    <!-- <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination> -->
    <!-- <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template> -->
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { clearLoginInfo } from "@/utils";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        userName: "",
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
      tableData: [],
      page: 1, // 当前页码
      limit: 100, // 每页数
      total: 0, // 总条数
    };
  },
  // computed: {
  //   dataRule() {
  //     var validateConfirmPassword = (rule, value, callback) => {
  //       if (this.dataForm.newPassword !== value) {
  //         return callback(
  //           new Error(this.$t("updatePassword.validate.confirmPassword"))
  //         );
  //       }
  //       callback();
  //     };
  //     return {
  //       password: [
  //         {
  //           required: true,
  //           message: this.$t("validate.required"),
  //           trigger: "blur",
  //         },
  //       ],
  //       newPassword: [
  //         {
  //           required: true,
  //           message: this.$t("validate.required"),
  //           trigger: "blur",
  //         },
  //       ],
  //       confirmPassword: [
  //         {
  //           required: true,
  //           message: this.$t("validate.required"),
  //           trigger: "blur",
  //         },
  //         { validator: validateConfirmPassword, trigger: "blur" },
  //       ],
  //     };
  //   },
  // },
  methods: {
    // 分页, 每页条数
    // pageSizeChangeHandle(val) {
    //   this.page = 1;
    //   this.limit = val;
    //   this.init();
    // },
    // // 分页, 当前页
    // pageCurrentChangeHandle(val) {
    //   this.page = val;
    //   this.init();
    // },
    init(item) {
      this.visible = true;
      this.$http
        .get("/sys/syshomestay/page", { params:{uid: this.dataForm.id }})
        .then((res) => {
          console.log(res);
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg);
          }
          this.tableData = res.data.data.list;
          this.total = res.data.total;
        })
        .catch(() => {});
    },
    // 多选
    handleSelectionChange(e) {
      console.log("e", e);
    },
  },
};
</script>
